<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { AnwAvatarRating } from '@anwalt.de/tailwind-design-system';
import { useProfileProductId } from '@/shared/stores/ProfileProductId';
import { useBaseProfileStore } from '@/shared/stores/BaseProfileStore';
import { useImage } from '@shared/composables/image';
import { useBaseRatingStore } from '@/shared/stores/BaseRatingStore';
import { computed } from 'vue';
import { TranslationHelper } from '@/shared/helper/TranslationHelper';
import { useBaseLawyerStore } from '@/shared/stores/BaseLawyerStore';

interface Props {
  hasInlineRating?: boolean;
  linkedProfile?: boolean;
  hasMobileFontSize?: boolean;
}

withDefaults(defineProps<Props>(), {
  hasInlineRating: false,
  linkedProfile: true,
});

const { profileProductId } = storeToRefs(useProfileProductId());
const { imagePath, displayedName, ratingUri, uri, profileProductIdText } = storeToRefs(useBaseProfileStore());
const { profile } = useBaseLawyerStore();
const imageUrlHost = import.meta.env.VITE_IMAGES_URL;
const { computedProfileImagePath } = useImage(imageUrlHost, imagePath.value, profileProductId.value);
const { rating, showRating } = useBaseRatingStore();

const { getTranslationByProductId, getGenderValueForTranslation } = TranslationHelper();

const profileImageAlt = computed(() => {
  return `${getTranslationByProductId('profileImage', profileProductId.value, {
    n: getGenderValueForTranslation(profile.sex),
  })} ${displayedName.value.trim()}`;
});
</script>

<template>
  <div class="xl:p-4 xl:pb-0 flex justify-items-start">
    <AnwAvatarRating
      :profileProductIdText="profileProductIdText"
      :profileImageSrc="computedProfileImagePath(80)"
      :profileSrc="linkedProfile ? uri : ''"
      :alt="profileImageAlt"
      :titleAtrribute="displayedName"
      :displayName="displayedName"
      :ratingSrc="ratingUri"
      :hasRating="showRating"
      :hasInlineRating="hasInlineRating"
      :ratingAverage="rating.ratingAverage"
      :numberOfRatings="rating.ratingCount"
      :hasMobileFontSize="hasMobileFontSize" />
  </div>
</template>
